<!--
 * @Author: JakeChiu
 * @Emaiil: 3289011@qq.com
 * @GitHub: https://github.com/zhakei988
 * @Date: 2022-01-20 16:30:27
 * @LastEditTime: 2026-01-23 10:23:56
 * @LastEditors: Please set LastEditors
 * @Description: JakeChiu in HX at Do not edit
 * @FilePath: \visualh5\src\components\PaymentResult.vue
-->
<template>
  <div class="paymentResult">

  </div>
</template>
<script>

export default {
  name: "PaymentResult",
  /**
   * @description: 本地存储
   * @param {*}
   * @return {*}
   */
  data() {
    return {
      returnurl:'',

    };
  },
  watch: {},
  methods: {
    /**
     * @description: 外部启动
     * @param {*} _data
     * @return {*}
     */
    init(_data) {
      //const url = _data.linkopt==1&&_data.linktype == 2?_data.href:location.href;
      //202470812 因不能传递clickid 所以不能直接传给抖音支付地址
      let url = location.href;
      // 如果登录完成，增加jump=1 20241025153555 frome dazhi
      url = url.indexOf('?')>-1?`${url}&jump=1`:`${url}?jump=1`
      setTimeout(function(){
        // 非快捷支付不用刷新页面，直接跳转购买地址
        window.dyModule.login(url);
      },300)
    },
  }
};
</script>
